(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["prelaunch"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var pops = document.querySelectorAll('[data-pop] .dotpop');
    if ('IntersectionObserver' in window) {
      var po = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-on');
            po.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      pops.forEach(function (el) { po.observe(el); });
    } else {
      pops.forEach(function (el) { el.classList.add('is-on'); });
    }

    var steps = document.querySelectorAll('[data-draw]');
    if (!('IntersectionObserver' in window)) {
      steps.forEach(function (el) { el.classList.add('is-drawn'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-drawn');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.35 });
      steps.forEach(function (el) { io.observe(el); });
    }

    // rail moved to assets/rumor-rail.js
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rumor-pdp"]) return;
  try {
    
  (function () {
    var compare = document.getElementById('RumorCompare');
    if (!compare) return;
    var line = compare.getAttribute('data-line') || 'electro';
    var maps = {
      electro: {
        sports: { label: 'Sports drinks', sweet: 'Cane sugar or corn syrup', dose: 'Built as a drink', format: 'You need the bottle', water: 'Required' },
        powders: { label: 'Powders', sweet: 'Often sugar or stevia blends', dose: 'A mixed serving', format: 'Needs water first', water: 'Required' },
        capsules: { label: 'Capsules', sweet: 'None. No taste.', dose: 'A dose without the taste', format: 'Swallow with water', water: 'Required' }
      },
      stress: {
        gummies: { label: 'Gummies', sweet: 'Often sugar or syrups', dose: 'Function varies by brand', format: 'A chew', water: 'Sometimes' },
        capsules: { label: 'Capsules', sweet: 'None. No taste.', dose: 'A dose without the taste', format: 'Swallow with water', water: 'Required' },
        candy: { label: 'Hard candy', sweet: 'Usually cane sugar', dose: 'Function optional', format: 'Hard candy', water: 'No' }
      }
    };
    var themData = maps[line] || maps.electro;
    var tabs = compare.querySelectorAll('.pdp-vs__tab');
    var themCol = document.getElementById('RumorThemCol');
    var rowSweet = document.getElementById('RumorRowSweet');
    var rowDose = document.getElementById('RumorRowDose');
    var rowFormat = document.getElementById('RumorRowFormat');
    var rowWater = document.getElementById('RumorRowWater');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-them');
        var data = themData[key];
        if (!data) return;
        tabs.forEach(function (t) {
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        if (themCol) themCol.textContent = data.label;
        if (rowSweet) rowSweet.textContent = data.sweet;
        if (rowDose) rowDose.textContent = data.dose;
        if (rowFormat) rowFormat.textContent = data.format;
        if (rowWater) rowWater.textContent = data.water;
        compare.setAttribute('data-them', key);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
